import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { ImgBase64Directive } from './img-base64.directive';
import { ImgPlaceholderDirective } from './img-placeholder.directive';

@NgModule({
  imports: [
    CommonModule
  ],
  declarations: [ImgBase64Directive, ImgPlaceholderDirective],
  exports: [ImgBase64Directive, ImgPlaceholderDirective]
})
export class DirectivesModule { }



// WEBPACK FOOTER //
// ./src/app/shared/directives/directives.module.ts